<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="languages">
    <!-- <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: miniAppId}"></ng-container> -->
    <img class="w-full" style="height: 25px;" [src]="'assets/images/logo/logo_XHUNT.png'">
</button>

<!-- Language menu -->
<mat-menu [xPosition]="'before'" #languages="matMenu">
    <ng-container *ngFor="let lang of availableMiniapps; trackBy: trackByFn">
        <button mat-menu-item (click)="changeMiniApps(lang)">
            <span class="flex items-center">
                <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: lang.id}"></ng-container>
                <span class="ml-3">{{lang.label}}</span>
            </span>
        </button>
    </ng-container>
</mat-menu>

<!-- Flag image template -->
<ng-template let-lang #flagImage>
    <span class="relative w-6 overflow-hidden">
        <span class="absolute inset-0"></span>
        <img *ngIf="lang" class="w-full" style="height: 25px;" [src]="'assets/images/logo/logo_' + lang + '.png'"
            [alt]="'Logo for app ' + lang">
    </span>
</ng-template>